import { render, staticRenderFns } from "./childTable.vue?vue&type=template&id=0cfe179c&scoped=true&"
import script from "./childTable.vue?vue&type=script&lang=js&"
export * from "./childTable.vue?vue&type=script&lang=js&"
import style0 from "./childTable.vue?vue&type=style&index=0&id=0cfe179c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfe179c",
  null
  
)

export default component.exports